import React from "react";
import { getUserCurrentlyAuthenticated } from "../modules/components/authentication";
import { useNavigate } from 'react-router-dom';
import { getUser } from "../modules/components/api";
import useWindowWide from "../modules/components/useWindowWide";
import DashboardScreenLayout from "../modules/views/DashboardScreenLayout";
import { Paper } from "@mui/material";
import DashboardDrawer from "../modules/views/DashboardDrawer";
import appCurvyLines from '../modules/components/img/appCurvyLines.png'
import logger from "../modules/components/logger";

const paperStyle = {
    backgroundImage: `url(${appCurvyLines})`,
    backgroundRepeat: 'repeat',
    minHeight: '100vh'
}

function Dashboard() {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const navigate = useNavigate();

  const isWide = useWindowWide(750);

  const [refresh, setRefresh] = React.useState(0);
  const [userInfo, setUserInfo] = React.useState({});

  React.useEffect(() => {
    getUserCurrentlyAuthenticated().then((user) => {
      getUser(user.username).then((res => {
        setUserInfo(res.data.getUserInfo);
      })).catch(logger.error)
    }).catch((reason) => {
      logger.info(reason);
      navigate('/');
    });
    // eslint-disable-next-line
  }, [navigate, refresh]);

  return (
    <Paper sx={paperStyle}>
      <DashboardScreenLayout
        userInfo={userInfo}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        refresh={refresh}
        setRefresh={setRefresh}
        isWide={isWide}
        drawer={<DashboardDrawer setOpen={setDrawerOpen} isCollector={userInfo?.collector} />}
      />
    </Paper>
  )
}

export default Dashboard;